import { useEffect, useRef } from 'react';

export const useTrackRenderCounts = (
  comp: string,
  identifier?: string | null
): void => {
  const renderCount = useRef(0);
  useEffect(() => {
    if (window.TRACK_COMPONENT_RENDER_COUNT) {
      renderCount.current++;
      const id = identifier?.replace(/\s+/g, '-').toLowerCase();
      const counterId = id ? `counter-${comp}-${id}` : `counter-${comp}`;

      sessionStorage.setItem(counterId, renderCount.current.toString());
    }
  });
};
